import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const headers = {
  "x-rapidapi-host": "coinranking1.p.rapidapi.com",
  "x-rapidapi-key": "7194e77c07msh0f7c25e64b80cd0p1bf192jsn9a076175e6dd",
};

const baseUrl = "https://coinranking1.p.rapidapi.com";

// const createRequest = (url) => ({
//   url,
//   params,
//   headers,
// });

// console.log(createRequest);

export const cryptoApi = createApi({
  reducerPath: "cryptoApi",
  baseQuery: fetchBaseQuery({
    baseUrl
  }),
  endpoints: (builder) => ({
    getCryptos: builder.query({
      query: (count) => ({
        url: "/coins",
        params: { timePeriod: "24h", orderBy: "marketCap", limit: count },
        headers: headers,
      }),
    }),
    getCryptoDetails: builder.query({
      query: (coinId) => ({
        url: `/coin/${coinId}`,
        headers: headers,
      }),
    }),
    // getExchanges: builder.query({
    //   query: () => ({
    //     url: "/exchanges",
    //     headers: headers,
    //   }),
    // }),
    getCryptoHistory: builder.query({
      query: ({ coinId, timeperiod }) => ({
        method: "GET",
        url: `/coin/razxDUgYGNAdQ/history`,
        params: { timeperiod: "1y" },
        headers: headers,
      }),
    }),
  }),
});

export const {
  useGetCryptosQuery,
  useGetCryptoDetailsQuery,
  useGetExchangesQuery,
  // useGetCryptoHistoryQuery,
} = cryptoApi
